import { render, staticRenderFns } from "./Specifications.vue?vue&type=template&id=75b8cfa5&"
import script from "./Specifications.vue?vue&type=script&lang=js&"
export * from "./Specifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports